const moment = require('moment')
const Vue = require('vue')
const Quill = require('quill')
const Delta = require('quill-delta')
const vueChaos = require('sci/helpers/vue-chaos')
const $ = require('jquery')
const { client, simpleCache } = require('sci/helpers')

const finalityClasses = {
    1: 'fa-phone',
    2: 'fa-group',
    3: 'fa-clock-o',
    4: 'fa-flag',
    5: 'fa-envelope',
    6: 'fa-tag',
    7: 'fa-microchip',
}

const newEvent = () => {
    return {
        start: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
        end: null,
        name: null,
        description: null,
        important: false,
        finished: false,
        status: 1,
        calendar_event_finality_id: null,
        all_day: false,
        type: 2
    }
}

Vue.component('form-event', {
    props: {
        label: {
            type: String
        },
        placeholder: {
            type: String
        },
        model: {
            twoWay: true,
            default: null
        },
        onSave: {
            type: Function,
            default: null
        },
        hideSaveButton: {
            type: Boolean,
            default: false
        },
        hideFinalities: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            form: newEvent(),
            finalities: [],
            loaded: false
        }
    },
    watch: {
        // form: {
        //     deep: true,
        //     handler: function (newVal, oldVal) {
        //         if (newVal === oldVal) {
        //             return;
        //         }
        //
        //         this.model = newVal;
        //     }
        // },
        model: {
            deep: true,
            handler: function (newVal, oldVal) {
            }
        },
        'model.start': function (newVal, oldVal) {
            if (newVal) {
                this.model.end = moment(newVal).add('15', 'minutes').format('YYYY-MM-DD HH:mm:ss')
            }
        },
        'model.all_day': function (newVal, oldVal) {
            if (newVal) {
                this.model.end = null
            }
        },
        'pseudoFinished': function (val) {
            if (!this.model) return

            if (val) {
                this.model.status = 2
            } else {
                this.model.status = 1
            }
        },
        'pseudoStatus': function (val) {
            if (!this.model) return

            if (val === 2) {
                this.model.finished = true
            } else if (val === 1) {
                this.model.finished = false
            }
        }
    },
    ready () {
        const preLoads = [

            simpleCache('calendars.events.finalities')
                .then(({ data }) => {
                    this.finalities = data
                })
        ]

        Promise.all(preLoads).then(() => {
            this.loaded = true
        })

        if (this.model === null) {
            this.model = newEvent()
        }
    },
    methods: {
        save () {
            const $form = $(this.$els.form)

            if (this.onSave) {
                this.onSave($form, newEvent())
            } else {
                this.internalSave($form)
            }
        },
        internalSave ($form) {
            client
                .silent()
                .block($form)
                .post('Salvando evento...', '/calendars/default/events', this.model)
                .then(vueChaos($form))
        },
        getFinalityClass (finality) {
            return finalityClasses[finality.type]
        },
        setFinality (finality) {
            this.model.name = finality.name
            this.model.calendar_event_finality_id = finality.id
        },
        getFinalityButtonClass (finality) {
            if (this.model.calendar_event_finality_id === finality.id) {
                return 'blue'
            }

            return 'btn-default'
        },
        clearFinality () {
            this.model.calendar_event_finality_id = null
            this.$els.clearFinalityButton.blur()
        },
        getForm () {
            return this.$els.form
        },
        resetForm () {
            this.model = newEvent()
        }
    },
    computed: {
        currentFinality () {
            return this.finalities.find(_ => _.id === this.model.calendar_event_finality_id)
        },
        pseudoStatus () {
            if (this.model) {
                return this.model.status
            }

            return 1
        },
        pseudoFinished () {
            if (this.model) {
                return this.model.finished
            }

            return false
        }
    },
    template: require('templates/components/form-event.html')
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/event.js